<template lang="pug">
.card-evbike-container(:class="{'new-module': newModule}")
  .evbikes
    template(v-if="evbikes && evbikes.length")
      .card-item(v-for="(item, index) in evbikes" :key="index")
        template(v-if="newModule")
          card-coupons-item-new(
            :btnIndex="index",
            :info="item",
            @btn="clickBtn(item)"
          )
        template(v-else)
          card-coupons-item(
            :info="item",
            @btn="clickBtn(item)"
          )
  .more.flex-mid(
    v-if="!newModule && data && data.length > 3 && !more",
    @click="showMore"
  )
    span 更多好券
    .common-arrow-down
  Confirm(
    v-if="confirmVisible",
    left-btn="暂不购买",
    right-btn="继续购买",
    @onLeft="cancel",
    @onRight="onConfirmRight",
    @close="cancel"
  )
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { CardService } from '@/service/card';
import Toast from '@/components/toast';
import Confirm from '../../card-for-app/components/confirm';
import CardCouponsItem from './card-coupon-item';
import CardCouponsItemNew from './card-coupon-item-new';
import { tryCatch } from '../../../utils';
import { welfareGo } from '../utils';

export default {
  components: {
    CardCouponsItem,
    CardCouponsItemNew,
    Confirm,
  },
  props: {
    data: {
      type: Array,
      default: () => ({
        buttonLink: '', // 按钮链接
        buttonText: '', // 按钮文字
        isCard: false, // 卡劵
        originalPriceText: '', // 原价
        price: '1', // 现价
        priceSubText: '', // 价格描述
        title: '', // 文字内容
      }),
    },
    newModule: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirmVisible: false,
      item: null,
      cashier: null,
      more: false,
    };
  },
  computed: {
    evbikes() {
      if (this.data.length > 3 && !this.more) {
        return this.data.slice(0, 3);
      }
      return this.data;
    },
  },
  watch: {
    evbikes: {
      deep: true,
      handler(newVal) {
        (newVal || []).forEach((item) => {
          if (item.isCard) {
            UBT.moduleExpose({
              pageId: 'Welfare',
              categoryId: 'platform',
              moduleId: 'platform_APP_card',
              contentId: 'platform_APP_card',
              exposureTimes: 1,
              businessInfo: {
                card_time: tryCatch(() => item.detail.commodityPackageItemDTO.cardBatchInfo.effectDay, '未知'),
                card_name: item.title,
                business: item.type,
              },
            });
          } else {
            UBT.moduleExpose({
              pageId: 'Welfare',
              categoryId: 'platform',
              moduleId: 'welfare_APP_coupon',
              contentId: 'welfare_APP_coupon',
              exposureTimes: 1,
              businessInfo: {},
            });
          }
        });
      },
    },
  },
  methods: {
    showMore() {
      this.more = !this.more;
    },
    // 购买
    clickBtn(item) {
      if (item.isCard) {
        this.item = item;
        this.confirmVisible = true;
        UBT.moduleExpose({
          pageId: 'Welfare',
          categoryId: 'platform',
          moduleId: 'Marketing_window',
          contentId: 'Marketing_window',
          exposureTimes: 1,
          businessInfo: {
            businessType: this.businessType,
          },
        });
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'platform_APP_card',
          categoryId: 'platform',
          businessInfo: {
            card_time: tryCatch(() => item.detail.commodityPackageItemDTO.cardBatchInfo.effectDay, '未知'),
          },
        });
      } else {
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'welfare_APP_coupon',
          categoryId: 'platform',
          businessInfo: {
            coupon_name: item.title,
          },
        });
        if (item.buttonLink) {
          welfareGo(item.buttonLink);
        }
      }
    },
    cancel() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'window_cancel',
        categoryId: 'platform',
        businessInfo: {
          businessType: this.businessType,
        },
      });
      this.confirmVisible = false;
    },
    onConfirmRight() {
      this.confirmVisible = false;
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'window_ok',
        categoryId: 'platform',
        businessInfo: {
          businessType: this.businessType,
        },
      });
      const info = this.item;
      if (!info) {
        Toast.show('未找到卡信息，请稍后重试');
        return;
      }
      this.buyCard(info);
    },
    goSuccess() {
      this.$router.push({
        path: '/card-for-app-success',
        query: { title: 'APP专享卡购买成功' },
      });
    },
    async buyCard(item) {
      CardService.buy(item.detail.commodityPackageItemDTO, item.params)
        .then(() => {
          this.goSuccess();
        })
        .catch((e) => {
          if (e) {
            Toast.showError(e);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.card-evbike-container {
  .evbikes {
    display: flex;
    flex-direction: column;
  }

  .card-item {
    &:not(:last-of-type) {
      margin-bottom: 0.12rem;
    }
  }

  .more {
    font-size: 0.12rem;
    color: #999;
    margin-top: 0.16rem;

    .common-arrow-down {
      border-color: #999;
    }
  }

  &.new-module {
    .evbikes {
      .card-item {
        &:not(:last-of-type) {
          margin-bottom: 0;
          padding-bottom: 0.16rem;
          border-bottom: 0.01rem solid #f7f9fa;
        }

        &:not(:first-of-type) {
          padding-top: 0.15rem;
        }
      }
    }
  }
}
</style>
